export const BUTTON_CELL_ACTION_DISPLAY_NAME = "ButtonCellAction";
